import IconCustom from "../components/IconCustom.vue";
import CardCustom from "../components/CardCustom.vue";
import DividerCustom from "../components/DividerCustom.vue";
import VueFeather from "vue-feather";

export default [VueFeather, IconCustom, DividerCustom, CardCustom];
